const api = '/service/err.php';
import axios from 'axios';
export const errRepository =  {
    methods: {
        async getAll(){
            return  axios.get(api);
        },
        async delete(err){
            return  axios.post(api,err);
        }
    }
};

